<template>
  <div :class="isEditMode ? 'd-flex flex-wrap' : 'row mb-3 p-2'">
    <!-- Divider Top -->
    <div class="col-12 mb-3" v-if="!isEditMode">
      <hr class="my-3">
    </div>

    <form @submit.prevent="handleSubmit" :class="isEditMode ? 'd-flex flex-wrap' : 'row'" autocomplete="off" :style="isEditMode ? '' : 'width: 100%'">

      <div class="row w-100">
        <!-- Is SMS -->
        <div class="col-lg-4">
          <input
            type="checkbox"
            :id="`isSms_${_uid}`"
            v-model="isSms"
          />
          <label :for="`isSms_${_uid}`" class="mx-1">
            {{ $t('tables.headers.isSms') }}
          </label>
        </div>

        <!-- Is WhatsApp -->
        <div class="col-lg-4">
          <input
            type="checkbox"
            :id="`isWhatsapp_${_uid}`"
            v-model="isWhatsapp"
          />
          <label :for="`isWhatsapp_${_uid}`" class="mx-1">
            {{ $t('tables.headers.isWhatsapp') }}
          </label>
        </div>

        <!-- Is Email -->
        <div class="col-lg-4">
          <input
            type="checkbox"
            :id="`isEmail_${_uid}`"
            v-model="isEmail"
          />
          <label :for="`isEmail_${_uid}`" class="mx-1">
            {{ $t('tables.headers.isEmail') }}
          </label>
        </div>
      </div>

      <div class="row w-100">
        <!-- Display Name -->
        <div class="col-lg-4">
          <formControl
            :label="$t('tables.headers.displayName')"
            type="text"
            name="displayName"
            v-validate="'required'"
            :val="displayName"
            @input="displayName = $event"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('displayName') : '')"
          />
        </div>

        <!-- Subject -->
        <div class="col-lg-4">
          <formControl
            :label="$t('tables.headers.subject')"
            type="text"
            name="subject"
            v-validate="'required'"
            :val="subject"
            @input="subject = $event"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('subject') : '')"
          />
        </div>

        <!-- Address (Email) -->
        <div class="col-lg-4">
          <formControl
            :label="$t('tables.headers.address')"
            type="text"
            name="address"
            :val="address"
            @input="address = $event"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('address') : '')"
          />
        </div>
      </div>

      <div class="row w-100">
        <!-- SMS Phone Number -->
        <div class="col-lg-4">
          <formControl
            :label="$t('tables.headers.smsPhoneNumber')"
            type="tel"
            name="smsPhoneNumber"
            :val="smsPhoneNumber"
            @input="smsPhoneNumber = $event"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('smsPhoneNumber') : '')"
          />
        </div>

        <!-- Auto Send -->
        <div class="col-lg-4">
          <formControl
            :label="'שליחה אוטומטית'"
            type="select"
            name="autoSend"
            :val="autoSend"
            @input="autoSend = $event"
            :options="autoSendOptions"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('autoSend') : '')"
          />
        </div>

        <!-- Model Allowed To Message (Multiselect) -->
        <div class="col-lg-4">
          <formControl
            :label="$t('tables.headers.modelAllowedToMassage')"
            type="multiselect"
            name="modelAllowedToMassage"
            v-validate="'required'"
            :val="modelAllowedToMassage"
            @input="modelAllowedToMassage = $event"
            :options="modelAllowedOptions"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('modelAllowedToMassage') : '')"
          />
        </div>
      </div>

      <div class="row w-100">
        <!-- Status (Only shows if autoSend is "כן" / 1) -->
        <div class="col-lg-4" v-if="autoSend == 1">
          <formControl
            :label="$t('tables.headers.statusId')"
            type="select"
            name="statusId"
            :val="statusId"
            @input="statusId = $event"
            :options="statusOptions"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('statusId') : '')"
          />
        </div>

        <!-- Reply To -->
        <div class="col-lg-4">
          <formControl
            :label="$t('tables.headers.replayTo')"
            type="text"
            name="replayTo"
            :val="replayTo"
            @input="replayTo = $event"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('replayTo') : '')"
          />
        </div>

        <!-- Mode Source -->
        <div class="col-lg-4">
          <formControl
            :label="$t('tables.headers.modeSource')"
            type="select"
            name="modeSource"
            v-validate="'required'"
            :val="modeSource"
            @input="modeSource = $event"
            :options="modeSourceOptions"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('modeSource') : '')"
          />

        </div>
      </div>

      <div class="row w-100">
        <!-- WhatsApp Template Name -->
        <div class="col-lg-12" v-if="isWhatsapp">
          <formControl
            :label="$t('tables.headers.whatsappTemplateName')"
            type="textarea"
            name="whatsappTemplateName"
            :val="whatsappTemplateName"
            @input="whatsappTemplateName = $event"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('whatsappTemplateName') : '')"
          />
        </div>

        <!-- WhatsApp Content -->
        <div class="col-lg-12" v-if="isWhatsapp">
          <formControl
            :label="$t('tables.headers.whatsappContent')"
            type="textarea"
            name="whatsappContent"
            :val="whatsappContent"
            @input="whatsappContent = $event"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('whatsappContent') : '')"
          />
        </div>

        <!-- Content (Email) -->
        <div class="col-lg-12" v-if="isEmail">
          <formControl
            :label="$t('tables.headers.content')"
            type="textarea"
            name="content"
            v-validate="'required'"
            :val="content"
            @input="content = $event"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('content') : '')"
          />
        </div>

        <!-- SMS Content -->
        <div class="col-lg-12" v-if="isSms">
          <formControl
            :label="$t('tables.headers.smsContent')"
            type="textarea"
            name="smsContent"
            :val="smsContent"
            @input="smsContent = $event"
            :maxlength="'130'"
            :error="isEditMode ? '' : ($parent ? $parent.errors.first('smsContent') : '')"
          />
          <span class="pull-left" v-if="smsContent">
            {{ smsContent ? smsContent.length : '' }}
          </span>
        </div>
      </div>

      <div class="row w-100">
        <!-- Is Edit File (Only shows if isEmail is checked) -->
        <div class="col-lg-3" v-if="isEmail">
          <input
            type="checkbox"
            :id="`isEditFile_${_uid}`"
            v-model="isEditFile"
          />
          <label :for="`isEditFile_${_uid}`" class="mx-1">
            {{ $t('tables.headers.isEditFile') }}
          </label>
        </div>

        <!-- Is Editable -->
        <div class="col-lg-3">
          <input
            type="checkbox"
            :id="`isEditable_${_uid}`"
            v-model="isEditable"
          />
          <label :for="`isEditable_${_uid}`" class="mx-1">
            {{ $t('tables.headers.isEditable') }}
          </label>
        </div>

        <!-- Is Show Message -->
        <div class="col-lg-3">
          <input
            type="checkbox"
            :id="`isShowMessage_${_uid}`"
            v-model="isShowMessage"
          />
          <label :for="`isShowMessage_${_uid}`" class="mx-1">
            {{ $t('tables.headers.isShowMessage') }}
          </label>
        </div>

        <div class="col-lg-3">
          <input
            type="checkbox"
            :id="`isRequiredPhoneBook_${_uid}`"
            v-model="isRequiredPhoneBook"
          />
          <label :for="`isRequiredPhoneBook_${_uid}`" class="mx-1">
            חייב איש קשר
          </label>
        </div>

      </div>


      <!-- Submit Button -->
      <div class="col-12 d-flex justify-content-center mb-2 mt-4">
        <button type="submit" class="btn btn-color-1" style="width: 200px;">
          <span>{{ isEditMode ? 'Edit' : 'Add' }}</span>
        </button>
      </div>
    </form>

    <!-- Divider Bottom -->
    <div class="col-12 mt-3" v-if="!isEditMode">
      <hr class="my-3">
    </div>
  </div>
</template>

<script>
import formControl from '@/components/formcontrol'

export default {
  name: 'MessageForm',
  components: { formControl },
  props: {
    mode: {
      type: String,
      default: 'add',  // 'add' or 'edit'
      validator: (value) => ['add', 'edit'].includes(value)
    },
    baseInfo: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isEditMode() {
      return this.mode === 'edit'
    },
    currentData() {
      if (this.isEditMode) {
        return this.editData
      }
      return this.addData
    },
    displayName: {
      get() { return this.currentData.displayName || '' },
      set(val) { this.$set(this.currentData, 'displayName', val) }
    },
    subject: {
      get() { return this.currentData.subject || '' },
      set(val) { this.$set(this.currentData, 'subject', val) }
    },
    address: {
      get() { return this.currentData.address || '' },
      set(val) { this.$set(this.currentData, 'address', val) }
    },
    smsPhoneNumber: {
      get() { return this.currentData.smsPhoneNumber || '' },
      set(val) { this.$set(this.currentData, 'smsPhoneNumber', val) }
    },
    autoSend: {
      get() { return this.currentData.autoSend || 0 },
      set(val) { this.$set(this.currentData, 'autoSend', val) }
    },
    modelAllowedToMassage: {
      get() { return this.currentData.modelAllowedToMassage || [] },
      set(val) { this.$set(this.currentData, 'modelAllowedToMassage', val) }
    },
    statusId: {
      get() { return this.currentData.statusId || '' },
      set(val) { this.$set(this.currentData, 'statusId', val) }
    },
    replayTo: {
      get() { return this.currentData.replayTo || '' },
      set(val) { this.$set(this.currentData, 'replayTo', val) }
    },
    modeSource: {
      get() { return this.currentData.modeSource || '' },
      set(val) { this.$set(this.currentData, 'modeSource', val) }
    },
    content: {
      get() { return this.currentData.content || '' },
      set(val) { this.$set(this.currentData, 'content', val) }
    },
    smsContent: {
      get() { return this.currentData.smsContent || '' },
      set(val) { this.$set(this.currentData, 'smsContent', val) }
    },
    whatsappContent: {
      get() { return this.currentData.whatsappContent || '' },
      set(val) { this.$set(this.currentData, 'whatsappContent', val) }
    },
    whatsappTemplateName: {
      get() { return this.currentData.whatsappTemplateName || '' },
      set(val) { this.$set(this.currentData, 'whatsappTemplateName', val) }
    },
    isSms: {
      get() { return this.currentData.isSms || false },
      set(val) { this.$set(this.currentData, 'isSms', val) }
    },
    isWhatsapp: {
      get() { return this.currentData.isWhatsapp || false },
      set(val) { this.$set(this.currentData, 'isWhatsapp', val) }
    },
    isEmail: {
      get() { return this.currentData.isEmail || false },
      set(val) { this.$set(this.currentData, 'isEmail', val) }
    },
    isEditFile: {
      get() { return this.currentData.isEditFile || false },
      set(val) { this.$set(this.currentData, 'isEditFile', val) }
    },
    isEditable: {
      get() { return this.currentData.isEditable || false },
      set(val) { this.$set(this.currentData, 'isEditable', val) }
    },
    isShowMessage: {
      get() { return this.currentData.isShowMessage || false },
      set(val) { this.$set(this.currentData, 'isShowMessage', val) }
    },
    isRequiredPhoneBook: {
      get() { return this.currentData.isRequiredPhoneBook || false },
      set(val) { this.$set(this.currentData, 'isRequiredPhoneBook', val) }
    },
    statusOptions() {
      // Get the raw statuses options
      const rawStatuses = this.isEditMode 
        ? (this.options['allStatuses'] || []) 
        : (this.$parent && this.$parent.tconfig ? this.$parent.tconfig.options['allStatuses'] : [])
      
      // Return a new array with ID appended to each status value
      return rawStatuses.map(status => ({
        ...status,
        value: status.value ? `${status.value} (${status.key})` : status.key
      }))
    }

  },
  mounted() {
    if (this.isEditMode && this.baseInfo) {
      // Initialize editData from baseInfo
      this.editData = JSON.parse(JSON.stringify(this.baseInfo))

      // Convert modelAllowedToMassage string to array if needed
      // if (typeof this.editData.modelAllowedToMassage === 'string') {
      //   const converted = this.editData.modelAllowedToMassage
      //     .split(',')
      //     .map(id => parseInt())
      //     .filter(id => !isNaN(id))
      //   this.$set(this.editData, 'modelAllowedToMassage', converted)
      // }
    } else if (this.$parent && this.$parent.newRowData) {
      // Initialize whatsappTemplateName in parent's newRowData if not exists
      if (!this.$parent.newRowData.hasOwnProperty('whatsappTemplateName')) {
        this.$parent.newRowData.whatsappTemplateName = ''
      }
    }
  },
  data() {
    return {
      addData: {},
      editData: {},
      autoSendOptions: [
        { key: 0, value: 'לא' },
        { key: 1, value: 'כן' },
      ],
      modelAllowedOptions: [
        { key: 1, value: 'הזמנות' },
        { key: 2, value: 'לידים' },
        { key: 3, value: 'לקוחות' },
        { key: 4, value: 'חידושים' },
        { key: 5, value: 'מחשבון' },
      ],
      modeSourceOptions: [
        { key: 'all', value: 'הכל' },
        { key: 'hova', value: 'hova' },
        { key: '10b', value: '10b' },
      ]
    }
  },
  methods: {
    handleSubmit() {

      if (this.isEditMode) {
        this.$emit('updateMessage', this.editData)
      } else {
        // Copy addData to parent's newRowData before submitting
        if (this.$parent && this.$parent.newRowData) {
          Object.assign(this.$parent.newRowData, this.addData)
        }
        if (this.$parent) {
          this.$parent.addNewRow()
        }
      }
    },
    getMessageData() {
      if (this.isEditMode) {
        return this.editData
      }
      return this.addData
    }
  },
  watch: {
    baseInfo: {
      handler(newVal) {
        if (this.isEditMode && newVal) {
          this.editData = JSON.parse(JSON.stringify(newVal))

          // Convert modelAllowedToMassage string to array if needed
          if (typeof this.editData.modelAllowedToMassage === 'string') {
            const converted = this.editData.modelAllowedToMassage
              .split(',')
              .map(id => parseInt(id))
              .filter(id => !isNaN(id))
            this.$set(this.editData, 'modelAllowedToMassage', converted)
          }

          this.$forceUpdate()
        }
      },
      deep: true
    },
    'editData.isEmail': function(newVal) {
      this.$forceUpdate()
    },
    'editData.isSms': function(newVal) {
      this.$forceUpdate()
    },
    'editData.isWhatsapp': function(newVal) {
      this.$forceUpdate()
    },
    'editData.modelAllowedToMassage': function(newVal) {
      this.$forceUpdate()
    },
    currentData: {
      handler(newVal) {
        this.$forceUpdate()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
</style>

